import Papa from 'papaparse';
import PropTypes from 'prop-types'
import { Helmet } from 'react-helmet-async';
import { Link } from "react-router-dom"
import React, { Component } from "react"
import { ToastContainer } from "react-toastify";
import Breadcrumbs from "../../components/Common/Breadcrumb"
import { Container, Button, Col, Card, CardBody, CardTitle } from "reactstrap"
import UploadRosterCSVForm from "./UploadRosterCSVForm";
import 'react-toastify/dist/ReactToastify.css';

// Utilities
import {
    createNotificationHelpers,
    createCampaigns,
    getCampaignList,
} from "../utils";

class UploadRosterCSV extends Component {
    constructor(props) {
        super(props)
        this.state = {
            shop: "",
            isShow: false,
            loading: false,
            message: "",
            store_details: {},
            store_status: "",
            campaign: null,
            discount: null,
            campaigns: [],
            keys: [],
            scrollCampaigns: [],
        }

        // Initialize notification helpers
        const notifications = createNotificationHelpers();
        this.notify_info = notifications.notify_info;
        this.notify_error = notifications.notify_error;
        this.notify_success = notifications.notify_success;
    }
    componentDidMount() {
        const { data } = this.props.location;
        if (!data) {
            return window.location.href = '/stores';
        }
        const { store_domain, store_details, store_status } = data;
        this.setState({
            shop: store_domain,
            store_details: { ...store_details },
            store_status
        })
    }


    /**
     * Handles form submission to create campaigns
     */
    handleValidSubmit = async (e) => {
        e.preventDefault();
        const { shop, campaigns } = this.state;

        if (!shop || !campaigns || campaigns.length === 0) {
            this.notify_error('Please upload all the files and show data first');
            return;
        }

        const result = await createCampaigns(shop, campaigns, this.notify_error);

        if (result) {
            if (result.status === false) {
                this.notify_error(result.message || "Failed to create campaigns");
                return;
            }

            this.setState({
                loading: true,
                isShow: false,
                campaigns: [],
                message: 'Campaigns created successfully.'
            });
            this.notify_success('Campaigns created successfully.');
        }
    }

    handleInputChange = (event) => {
        Papa.parse(event.target.files[0], {
            header: true,
            skipEmptyLines: true,
            complete: this.updateResult
        });
    }

    handleDiscountInputChange = (event) => {
        Papa.parse(event.target.files[0], {
            header: true,
            skipEmptyLines: true,
            complete: this.updateDiscountResult
        });
    }

    updateResult = result => {
        this.setState({ campaign: result.data, isShow: false });
    }

    updateDiscountResult = result => {
        this.setState({ discount: result.data, isShow: false });
    }

    handleTableView = () => {
        const { campaign, discount, shop } = this.state;
        if (!campaign || !discount) {
            this.notify_error(`Please upload both files.`);
            return;
        }

        const updatedCampaign = campaign.map((ele, index) => {
            const link = ele['Referral Link']
            let coupons = ele['Shareable Codes']
            let coupon = coupons ? coupons.split(',')[0] : '';

            const campaign_id = link.split('rstr=')?.[1] || link.split('code=')?.[1] || ''
            const data = discount.find(item => item['Name'] === coupon);
            let camp_object = {
                sn: index + 1,
                name: ele['Full Name'],
                link,
                code: campaign_id,
                coupon: coupon,
                discount_type: 'Flat',
                status: 'enabled',
                minimum_purchase: 0,
            }

            if (data) {
                // Convert the discount value to a number if it's a string
                let type = (data['Value Type'] === 'percentage') ? 'Flat' : 'Fixed';
                return {
                    ...camp_object,
                    discount: Math.abs(data['Value']),
                    discount_type: type,
                    minimum_purchase: data['Minimum Purchase Requirements'] || 0,
                    status: data['Status'] === 'Active' ? 'enabled' : 'disabled',
                }
            }

            return {
                ...camp_object,
                discount: 10,
            }
        });
        const keys = Object.keys(updatedCampaign[0]);
        this.setState({ campaigns: updatedCampaign, keys, isShow: true });
    }

    /**
     * Loads all campaigns for the shop
     */
    handleCampaigs = async () => {
        this.notify_info("Loading campaigns ...");
        const { shop } = this.state;

        const data = await getCampaignList(shop, this.notify_error);

        if (!data || data.length === 0) {
            this.notify_error("No campaigns found or error occurred while loading campaigns.");
            return;
        }

        let sn = 1;
        const campaigns = data.map(item => ({
            sn: sn++,
            name: item.name,
            code: item.code,
            link: item.link,
            target: item.target,
            schedule: item.schedule,
            discount_type: item.discount_type,
            recipients: item.recipients,
            price_rounding: item.price_rounding,
            minimum_purchase: item.minimum_purchase,
            status: item.status,
        }));

        this.notify_success("Campaigns loaded successfully.");
        const keys = Object.keys(campaigns[0] || {});
        this.setState({
            keys,
            campaigns: campaigns,
            scrollCampaigns: campaigns.slice(0, 10)
        });
    }



    handleScroll = (e) => {
        const { campaigns, scrollCampaigns } = this.state;
        const newCampaigns = campaigns.slice(scrollCampaigns.length, scrollCampaigns.length + 10);
        this.setState({ scrollCampaigns: [...scrollCampaigns, ...newCampaigns] });

    };

    render() {
        const { shop, loading, store_details, campaigns, store_status, keys, isShow, message, scrollCampaigns } = this.state;
        return (
            <React.Fragment>
                <div className="page-content">
                    <Helmet>
                        <title>Veeper | AP - Upload CSV</title>
                    </Helmet>
                    <Container fluid>
                        <Breadcrumbs
                            title={("Upload CSV")}
                            breadcrumbItem={("CSV Upload")}
                        />
                        <ToastContainer />
                        <Col md={12}>
                            <Card>
                                <CardBody>
                                    <CardTitle className="h4"></CardTitle>
                                    <Link to={{ pathname: "/merchant-details", state: { data: store_details, storeStatus: store_status } }} style={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center' }}>
                                        <Button className="btn btn-dark">
                                            <i className="fa fa-arrow-left"></i> Store Details
                                        </Button>
                                    </Link>

                                    <UploadRosterCSVForm
                                        shop={shop}
                                        isShow={isShow}
                                        onInputChange={this.handleInputChange}
                                        onDiscountInputChange={this.handleDiscountInputChange}
                                        onSubmit={this.handleValidSubmit}
                                        onShowData={this.handleTableView}
                                        onShowAllCampaigns={this.handleCampaigs}
                                    />
                                </CardBody>
                            </Card>
                        </Col>
                        <Col md={12}>
                            {scrollCampaigns.length > 0 && (
                                <div className="table-responsive" >
                                    <h2> Campaign Records </h2>
                                    <table className="table">
                                        <thead>
                                            <tr>
                                                {keys.map((item, idx) => (
                                                    <th key={idx}>{item}</th>
                                                ))}
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {scrollCampaigns.map((item, idx) => (
                                                <tr key={idx}>
                                                    {keys.map((key, idx) => (
                                                        <td>{item[key]}</td>
                                                    ))}
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>

                                </div>
                            )}
                        </Col>

                        {scrollCampaigns.length < campaigns.length && (
                            <div className="loading" style={{
                                padding: '8px 16px',
                                width: '200px',
                                margin: ' 10px auto',
                                fontSize: '16px',
                                cursor: 'pointer',
                                color: '#000',
                                border: 'none',
                                borderRadius: '999px',
                                textAlign: 'center',
                                border: '1px solid #ccc',
                            }} onClick={this.handleScroll}>More ...</div>
                        )}

                    </Container>
                </div>
            </React.Fragment>
        )
    }
}

UploadRosterCSV.propTypes = {
    t: PropTypes.any
}
export default UploadRosterCSV
